/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SessionsInputs */

const th_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซสชัน`)
};

const en_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const ja_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッション`)
};

const zh_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程`)
};

const es_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones`)
};

const pt_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessões`)
};

const id_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi`)
};

const fr_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances`)
};

const tl_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga sesyon`)
};

const vi_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi tập`)
};

const ko_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세션`)
};

const de_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten`)
};

const ru_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Занятия`)
};

const tr_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturumlar`)
};

const it_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessioni`)
};

const pl_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia`)
};

const uk_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заняття`)
};

const hi_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्र`)
};

const ar_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحصص`)
};

const ms_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi`)
};

const bn_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেশন`)
};

const zh_tw2_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`課程`)
};

const zh_hk2_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`課節`)
};

const ur_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سیشن`)
};

const fa_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جلسات`)
};

const sw_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vipindi`)
};

const nl_event_sessions = /** @type {(inputs: Event_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessies`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Event_SessionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_sessions = /** @type {((inputs?: Event_SessionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SessionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_sessions(inputs)
	if (locale === "ja") return ja_event_sessions(inputs)
	if (locale === "zh") return zh_event_sessions(inputs)
	if (locale === "es") return es_event_sessions(inputs)
	if (locale === "pt") return pt_event_sessions(inputs)
	if (locale === "id") return id_event_sessions(inputs)
	if (locale === "fr") return fr_event_sessions(inputs)
	if (locale === "tl") return tl_event_sessions(inputs)
	if (locale === "vi") return vi_event_sessions(inputs)
	if (locale === "ko") return ko_event_sessions(inputs)
	if (locale === "de") return de_event_sessions(inputs)
	if (locale === "ru") return ru_event_sessions(inputs)
	if (locale === "tr") return tr_event_sessions(inputs)
	if (locale === "it") return it_event_sessions(inputs)
	if (locale === "pl") return pl_event_sessions(inputs)
	if (locale === "uk") return uk_event_sessions(inputs)
	if (locale === "hi") return hi_event_sessions(inputs)
	if (locale === "ar") return ar_event_sessions(inputs)
	if (locale === "ms") return ms_event_sessions(inputs)
	if (locale === "bn") return bn_event_sessions(inputs)
	if (locale === "zh-TW") return zh_tw2_event_sessions(inputs)
	if (locale === "zh-HK") return zh_hk2_event_sessions(inputs)
	if (locale === "ur") return ur_event_sessions(inputs)
	if (locale === "fa") return fa_event_sessions(inputs)
	if (locale === "sw") return sw_event_sessions(inputs)
	if (locale === "nl") return nl_event_sessions(inputs)
	return en_event_sessions(inputs)
});